import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { formatPrice, getProductSalePrice } from "../../../utils/utils";
import useLang from "../../../hooks/useLang";
import { addItemToCart } from "../../../apis/requests";
import { setCartCount } from "../../redux/reducer";
import store from "../../redux/store";
import { useTranslation } from "react-i18next";

const VariationProduct = (props) => {
    const lang = useLang();
    const item = props.item.variation;
    const variations = props.item.variationValues;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [itemPrice, setItemPrice] = useState({});
    const [addToCartLoading, setAddToCartLoading] = useState(false);

    useEffect(() => {
        setItemPrice(getProductSalePrice({
            selling_price: item.variation_selling_price,
            discounted_price: item.variation_discounted_price,
            discount_end_date: item.variation_discount_end_date,
            discount_start_date: item.variation_discount_start_date,
        }));
    }, []);
    const handleAddItemToCart = async () => {
        try {
            if (item.type === "simple" && item.product_fields === null) {
                setAddToCartLoading(true);
                let cartId = localStorage.getItem('cart') === null ? crypto.randomUUID() : localStorage.getItem('cart');
                let data = {
                    cart_id: cartId,
                    product: {
                        id: item.id,
                        fields: {

                        }
                    },
                    quantity: 1,
                    type: item.type,
                }
                const res = await addItemToCart(data);
                localStorage.setItem('cart', cartId);
                store.dispatch(setCartCount(res.data.cart_count))
                setAddToCartLoading(false);
                props.showToast();

            } else {
                navigate('/shop/products/var/' + item.variation_sku, { state: item });
            }
        } catch (error) {
            console.log(error);

        }


    }
    return (
        <div>
            <div className="max-w-sm overflow-hidden m-2" >
                <div
                    className="prod-add-to-fav"
                    style={{
                        position: "relative",
                        top: 50,
                    }}
                >
                    <Button
                        style={{
                            height: 40,
                            width: 40
                        }}
                        rounded
                        severity="secondary"
                        icon={<span className="material-symbols-outlined">favorite</span>}
                    />
                </div>
                <div>
                    <Link
                        to={'/shop/products/var/' + item.variation_sku}
                        state={item}
                    >
                        <img className="w-full rounded bg-gray-100" src={item.variation_image} alt={item.variation_name} loading="lazy" />
                    </Link>
                    <div>
                        <div className="mt-3 mx-2">
                            <div className="flex justify-between">
                                <div>
                                    <div>
                                        <Link
                                            to={'/shop/products/var/' + item.variation_sku}
                                            state={item}
                                        >
                                            <span className="text-black lg:text-base md:text-base text-sm font-semibold">{lang === "en" ? item.variation_name : item.variation_name_ar}</span>
                                        </Link>
                                    </div>
                                    <div>
                                        <span className="text-sm font-bold">{itemPrice.price}</span>
                                        {
                                            (itemPrice.discount) &&
                                            <span className="text-sm mx-1 hide-xs"
                                                style={{
                                                    textDecorationLine: "line-through"
                                                }}
                                            >{formatPrice(item.selling_price, false)}</span>
                                        }
                                    </div>
                                </div>
                                <div
                                    style={{
                                        marginLeft: 10
                                    }}>
                                    <Button
                                        loading={addToCartLoading}
                                        style={{
                                            height: 40,
                                            width: 40
                                        }}
                                        rounded
                                        outlined
                                        severity="secondary"
                                        icon={<span className="material-symbols-outlined">shopping_cart</span>}
                                        onClick={() => {
                                            handleAddItemToCart();
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="fex">
                                {
                                    variations.map((v, i) => {
                                        return (
                                            <div key={i} className="">
                                                <span className="font-semibold text-gray-600"><span>{lang === "en" ? v.type : v.type_ar} <span> - </span></span>{v.value}</span>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
VariationProduct.propTypes = {
    item: PropTypes.object.isRequired,
    variations: PropTypes.array.isRequired,
    showToast: PropTypes.func.isRequired
}
export default VariationProduct;
